"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.areVideoPreferencesEqual = areVideoPreferencesEqual;
exports.buildVideoPreferences = void 0;
exports.getCameraAndScreenShareSourcesInProgram = getCameraAndScreenShareSourcesInProgram;
var _Sources = require("@studio/constants/Sources");
var _amazonChimeSdkJs = require("amazon-chime-sdk-js");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function getCameraAndScreenShareSourcesInProgram(program) {
  return program === null || program === void 0 ? void 0 : program.layers.filter(function (programLayer) {
    var _programLayer$source, _programLayer$source2;
    return [_Sources.CAMERA_PRESENTER, _Sources.SCREEN_PRESENTER].includes((_programLayer$source = programLayer.source) === null || _programLayer$source === void 0 ? void 0 : _programLayer$source.type) && ((_programLayer$source2 = programLayer.source) === null || _programLayer$source2 === void 0 ? void 0 : _programLayer$source2.value) !== _Sources.UNASSIGNED;
  }).map(function (item) {
    return item.source.value;
  });
}

/**
 * Compares two sets of video preferences to determine if they are equal. Used so be don't
 * update the video preferences if they haven't changed.
 */
function areVideoPreferencesEqual(prevPreferences, newPreferences) {
  if (!prevPreferences || !newPreferences) {
    return false;
  }
  var prevMap = new Map();
  var _iterator = _createForOfIteratorHelper(prevPreferences),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var pref = _step.value;
      if (pref && pref.attendeeId !== undefined && pref.priority !== undefined) {
        prevMap.set(pref.attendeeId, pref.priority);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(newPreferences),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _pref = _step2.value;
      if (prevMap.get(_pref.attendeeId) !== _pref.priority) {
        return false;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return prevPreferences.length === newPreferences.length;
}

/**
 * Builds video preferences based on sources in and not in the program.
 * @param {Array} inProgramSources - Sources in the program.
 * @param {Array} notInProgramSources - Sources not in the program.
 * @returns {Array} - Built video preferences.
 */
var buildVideoPreferences = exports.buildVideoPreferences = function buildVideoPreferences(inProgramSources, notInProgramSources) {
  var videoPreferences = _amazonChimeSdkJs.VideoPreferences.prepare();

  /**
   * This is to avoid very low resolutions (like 136p) when there are 3 or 4 cameras on.
   * With 3 or 4 cameras on, senders will be sending 540p as per default uplink policy
   * and quite possibly 3 SVC layers. If we choose LOW, we'll be receiving the lowest layer (e.g. 136p)
   * but as soon as no. of cameras go to 5, expected resolution changes to 480p and senders will be sending only 2 layers
   * In that case, LOW changes to something like 240p.
   * So even though the no. of camera have increased, there is an increase in resolution which is counter-intuitive and confusing
   * Also, 136p looks terrible in presenter gallery view
   * To mitigate this, we'll request MEDIUM until 5 sources (might include screenshare)
   * and after that, it'll be LOW to keep resolutions consistent
   */
  var targetDisplaySizeForOffStageAttendees = _amazonChimeSdkJs.TargetDisplaySize.Low;
  var totalSourcesInSession = inProgramSources.length + notInProgramSources.length;
  if (totalSourcesInSession <= 5) {
    targetDisplaySizeForOffStageAttendees = _amazonChimeSdkJs.TargetDisplaySize.Medium;
  }
  inProgramSources.forEach(function (value) {
    videoPreferences.add(new _amazonChimeSdkJs.VideoPreference(value, 1, _amazonChimeSdkJs.TargetDisplaySize.High));
  });
  notInProgramSources.forEach(function (value) {
    videoPreferences.add(new _amazonChimeSdkJs.VideoPreference(value, 2, targetDisplaySizeForOffStageAttendees));
  });
  return videoPreferences.build();
};